import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface ILinkButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function ButtonLink({ children, onClick, className }: ILinkButtonProps) {
  return (
    <button type="button" className={cx(styles['link'], className)} onClick={onClick}>
      {children}
    </button>
  );
}
